export default __webpack_public_path__ + "ac0fdc5e3d9611e434ebd572cb2bfa71.svg";